import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  Grid,
  Box,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { FormProvider, useForm } from "react-hook-form";

import Loader from "../components/Loader/Loader";
import RadioTabs from "../components/RadioTabs/RadioTabs";
import FlightBadge from "../components/FlightBadge/FlightBadge";
import FlightDetails from "../steps/Step1/organisms/FlightDetails";
import { CustomSwitch } from "../components/Switch/Switch";
import FormOperator from "../components/FormOperator/FormOperator";
import AccomodationCard from "../components/AccomodationCard/AccomodationCard";
import NextButton from "../components/NextButton/NextButton";
import useStyles from "../steps/Step1/styles";
import Accreditation from "../components/Accreditation/Accreditation";

export default function FirstStepViewPage() {
  const [apiData, setApiData] = useState({});
  const { token, priceQuoteId } = useParams();
  const classes = useStyles();

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      if(window.userData){
        setApiData(window.userData);
      }
    }

    return () => (mounted = false);
  }, []);

  const methods = useForm({
    shouldUnregister: false,
    defaultValues: apiData?.result,
    resolver: undefined,
    mode: "onChange",
  });

  return (
    <FormProvider {...methods}>
      <form style={{ paddingBottom: "50px", height: "100%" }}>
        <Grid container style={{ height: "100%" }}>
          {typeof apiData === "object" && Object.keys(apiData).length > 1 ? (
            <FirstStepViewForm classes={classes} apiData={apiData} />
          ) : (
            <Grid container>
              <Grid item xs={12} className={classes.mainForm}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  flexDirection="column"
                >
                  {typeof apiData === "string" ? (
                    <Typography variant="h2">{apiData}</Typography>
                  ) : (
                    <Loader />
                  )}
                </Box>
              </Grid>
            </Grid>
          )}
        </Grid>
      </form>
    </FormProvider>
  );
}

const FirstStepViewForm = ({ classes, apiData }) => {
  const theme = useTheme();
  const show = useMediaQuery(theme.breakpoints.down("sm"));

  const selectedFlight = apiData?.priceQuotes.find(
    (item) => item.id == apiData?.result?.flight
  );

  if(!selectedFlight?.parts?.multiple){
    delete selectedFlight?.parts?.multiple
  }

  return (
    <>
      <Grid item xs={12} md={8} className={classes.mainForm}>
        <Box mb={2.5}>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            className={classes.formHeader}
          >
            <Typography variant="h3" align="center">
              Please choose your preferred flight option
            </Typography>
            <Typography variant="body1" align="center">
              A few simple steps
            </Typography>
          </Box>
        </Box>
        <Box mb={2.5}>
          <Grid container spacing={1}>
            <RadioTabs
              name="flight"
              options={apiData?.priceQuotes}
              airlines={apiData?.airlines}
              defaultValue={apiData?.result?.flight}
            />
          </Grid>
        </Box>
        <Box
          mb={2.5}
          display="flex"
          justifyContent="center"
          className={classes.ticketHeader}
        >
          <Box display="flex" alignItems="center">
            <Typography variant="h2">Flight Details</Typography>
            {selectedFlight?.badge && (
              <Box ml={1}>
                <FlightBadge info={selectedFlight?.badge} />
              </Box>
            )}
          </Box>
        </Box>
        <Box>
          <Grid container>
            {selectedFlight?.parts?.hasOwnProperty('depart') && Object.keys(selectedFlight?.parts?.depart)?.length > 0 && (
              <FlightDetails
                type="depart"
                flightDetail={selectedFlight?.parts?.depart}
                flightNumber="1"
                airlines={apiData?.airlines}
                airports={apiData?.airports}
              />
            )}
            {selectedFlight?.parts?.hasOwnProperty('return') && Object.keys(selectedFlight?.parts?.return)?.length > 0 && (
              <FlightDetails
                type="return"
                flightDetail={selectedFlight?.parts?.return}
                flightNumber="1"
                airlines={apiData?.airlines}
                airports={apiData?.airports}
              />
            )}
            {selectedFlight?.parts?.multiple?.map((part, index) => (
              <FlightDetails
                type="multiple"
                flightDetail={part}
                flightNumber={index + 1}
                airlines={apiData?.airlines}
                airports={apiData?.airports}
              />
            ))}
          </Grid>
        </Box>
        {selectedFlight?.accomodation && (
          <Box>
            <Box
              mb={2.5}
              display="flex"
              justifyContent="center"
              className={classes.ticketHeader}
            >
              <Box display="flex" alignItems="center">
                <Typography variant="h2">Hotel Details</Typography>
              </Box>
            </Box>
            <AccomodationCard accomodationInfo={selectedFlight?.accomodation} />
          </Box>
        )}
      </Grid>
      <Grid
        container
        item
        xs={12}
        md={4}
        className={classes.secondaryForm}
        justify="center"
        alignItems="center"
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          mb={1}
          className={classes.itinerarySection}
        >
          <Box>
            <Typography variant="h2" align="center">
              Booking almost completed
            </Typography>
          </Box>
          <Box mb={1.5}>
            <Typography variant="body1" align="center">
              Double check your tickets and click confirm
            </Typography>
          </Box>
          <CustomSwitch
            name="itinerarySwitch"
            value={apiData?.result?.itinerarySwitchValue}
            defaultValue={apiData?.result?.itinerarySwitchValue}
            label="I confirm this itinerary"
          />
          {!show && (
            <Box mt={2}>
              <NextButton
                selectedFlight={selectedFlight}
                handleNext={() => {}}
                disabled={true}
                location="form"
                tipsValue={apiData?.result?.tips}
              />
            </Box>
          )}
        </Box>
        <Box width={1}>
        <FormOperator operatorInfo={apiData?.operatorInfo} />
          <Accreditation />
        </Box>
      </Grid>
    </>
  );
};
